<template>
  <div>
    <!-- This row is for displaying scroll-icon -->
    <div class="row slanted-container-left"> <!-- NOTE: slanted container has bottom offset to overlay image -->
      <!--<div class="col-12 scroll-icon">
        <img v-on:click="scroll_top" width="50px" src="/static/images/scroll-icon.png" />
      </div>-->
    </div>

    <!-- Footer content -->
    <div class="footer-content anti-slanted-offset">
      <div class="row justify-content-center mb-6 mb-md-7 mb-xl-9">

        <!-- Contact -->
        <div class="col-6 col-md-3 col-lg-2 px-0 mx-3 mx-lg-4 d-none d-md-block">
          <h4>{{ $t('message.headerFooter.contact') }}</h4>
          <ul class="list-unstyled">
            <li class="media">
              <a href="https://www.google.se/maps/place/Kungsgatan+47,+753+20+Uppsala/@59.8598107,17.639066,17z/data=!3m1!4b1!4m5!3m4!1s0x465fcbf77bc22bc5:0xc5563a8fb702ae6f!8m2!3d59.8598107!4d17.6412547"
              target="_blank">
                <img src='/static/images/icon_address.svg' class="mr-2 icon-sm button-pop" alt="Office Address">
              </a>
              <div class="media-body align-self-center">
                <p class="mb-0">{{ $t('message.contact.address') }}</p>
                <p class="mb-0">{{ $t('message.contact.city') }}</p>
              </div>
            </li>

            <li class="media my-3">
              <!-- TODO -->
              <a href="tel:+46738000099">
                <img class="mr-2 icon-sm button-pop" src="/static/images/icon_phone_1600px_space_blue.png" alt="Phone number">
              </a>
              <div class="media-body align-self-center">
                <p class="mb-0 text-nowrap">{{ $t('message.contact.phoneNumber') }}</p>
              </div>
            </li>

            <li class="media my-3">
              <!-- TODO -->
              <a href="mailto:info@precisit.se">
                <img src='/static/images/icon_mail.svg' class="mr-2 icon-sm button-pop" alt="Contact e-mail addresses">
              </a>
              <div class="media-body align-self-center">
                <p class="mb-0">{{ $t('message.contact.emailInfo') }}</p>
              </div>
            </li>
          </ul>
          </div>

          <!-- Interested? -->
          <div class="col-6 col-md-3 col-lg-2 px-0 mr-3 mr-lg-5 text-center text-md-left d-none d-md-block ">
            <h4>{{ $t('message.headerFooter.interested') }}</h4>
            <p>{{ $t('message.headerFooter.txtCv') }}</p>
          </div>

          <!-- Get to know -->
          <div class="col-6 col-md-3 col-lg-2 px-0 mx-3 mx-lg-4 mb-3 text-center text-md-left text-nowrap">
            <h4 class="text-nowrap">{{ $t('message.headerFooter.knowUs') }}</h4>
            <a href="https://www.facebook.com/Precisit/" target="_blank">
              <img src='/static/images/icon_facebook.svg' class="m-1 icon-sm button-pop" alt="Facebook icon">
            </a>
            <a href="https://www.instagram.com/teamprecisit/" target="_blank">
              <img src='/static/images/icon_instagram.svg' class="m-1 icon-sm button-pop" alt="Instagram icon">
            </a>
            <a href="https://www.linkedin.com/company/precisit-ab/" target="_blank">
              <img src='/static/images/icon_linkedin.svg' class="m-1 icon-sm button-pop" alt="LinkedIn icon">
            </a>
            <a href="https://twitter.com/teamprecisit?lang=en" target="_blank">
              <img src='/static/images/icon_twitter.svg' class="m-1 icon-sm button-pop" alt="Twitter icon">
            </a>
          </div>

          <!-- Displayed only on mobile: Botton with link to contact page -->
          <div class="col-6 text-center my-3 d-md-none">
            <h4>{{ $t('message.headerFooter.interested') }}</h4>
            <p class="mb-0">{{ $t('message.headerFooter.txtMobile1') }}</p>
            <p class="mb-0">{{ $t('message.headerFooter.txtMobile2') }}</p>
            <p class="mb-0">{{ $t('message.headerFooter.txtMobile3') }}</p>
            <p class="mb-0">{{ $t('message.headerFooter.txtMobile4') }}</p>
          </div>
          <div class="col-8 text-center my-2 d-md-none justify-content-center">
            <div class="cta-button-container mx-auto">
              <router-link to="Contact">
                <div class="cta-button">{{ $t('message.button.contact') }}</div>
              </router-link>
            </div>
          </div>

        </div>
      <img class="astronaut icon-md" src="/static/images/astronaut_simple.png">
    </div>

  </div>
</template>

<script>
export default {
  name: 'PageFooter',
  data() {
    return {};
  },
  methods: {
    // eslint-disable-next-line
    scroll_top: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
    // eslint-disable-next-line
    scroll_first_section: function () {
      window.scroll({ top: 650, left: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/_variables.scss';
@import '../../assets/styles/_slanted.scss';

// NOTE: this is to counteract the offset from the slanted div. The slanted div has an offset to overlay the image.
.anti-slanted-offset {

@include media-breakpoint-down(sm) {
  margin-top: -2.5em;
 }
 @include media-breakpoint-up(lg) {
  margin-top: -3em;
 }
}

@keyframes slideInFromBottom {
  0% {
    transform: translateY(+200%);
  }
  100% {
    transform: translateY(0);
  }
}

.astronaut {
  //animation: 2s ease-out 0s 1 slideInFromBottom;
  position: absolute;
  right: -1em;
  transform: rotate(-33deg);
  bottom: -4em;
}

.footer-content{
  position: relative;
  overflow: hidden;
  background-color:white;
}

.icon-sm {
  width: 40px;
}

.icon-md {
  width: 100px;
}

h4 {
  color: $light-grey;
  font-size: 24px;
}

.scroll-icon {
  z-index: 11;
  transform: rotate(180deg);
}

.slanted-container-left {
  @include slanted-container-left(rgba(white, 0), rgba(white, 1));
}

.button-pop:hover {
  transform: scale(1.2);
}

</style>
